














import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import I18nMixin from '@/Shared/I18nMixin';

export default mixins(LocationBasedMixin, I18nMixin).extend({
    computed: {
        i18nPrefix() {
            return 'payment.error';
        }
    }
});
